import React from 'react';
import moment from 'moment';
import cx from 'classnames';

const dateRenderer = (date) => {
  if (!date) {
    return null;
  }
  return moment(date).format('DD/MM/YYYY HH:mm');
};

const distanceRenderer = ({ km_from, km_to, intl, domain_code }) => {
  if (!km_from && !km_to) {
    return 'All distances';
  }

  return `from ${km_from} to ${km_to} Km`;
};

const palletsRenderer = ({ pallets_from, pallets_to }) => {
  if (!pallets_from && !pallets_to) {
    return 'All pallets';
  }

  return `from ${pallets_from} to ${pallets_to} Eu`;
};

const weightRenderer = ({ kg_from, kg_to }) => {
  if (!kg_from && !kg_to) {
    return 'All weights';
  }

  return `from ${kg_from} to ${kg_to} Kg`;
};

const priceRenderer = ({ price }) => {
  return `${price}`;
};

const zipcodesRenderer = (conditions, key) => {
  return ((conditions || {})[key] || []).join(', ');
};

const ContractLine = ({ contract }) => {
  const { price, conditions, starts_at, ends_at } = contract;

  return (
    <tr
      className={cx('contractLine', {
        contractLine__inactive: !!ends_at,
      })}
    >
      <td className="contractLine__cell contractLine__center">#{contract.id}</td>
      <td className="contractLine__cell contractLine__right" width="60">
        {priceRenderer({ price })}
      </td>
      <td className="contractLine__cell" width="60">
        {dateRenderer(starts_at)}
      </td>
      <td className="contractLine__cell" width="60">
        {dateRenderer(ends_at)}
      </td>
      <td className="contractLine__cell" width="60">
        {weightRenderer(conditions)}
      </td>
      <td className="contractLine__cell" width="80">
        {distanceRenderer(conditions)}
      </td>
      <td className="contractLine__cell" width="80">
        {palletsRenderer(conditions)}
      </td>
      <td className="contractLine__cell" width="80">
        {zipcodesRenderer(conditions, 'pickup_zipcodes')}
      </td>
      <td className="contractLine__cell" width="80">
        {zipcodesRenderer(conditions, 'dropoff_zipcodes')}
      </td>
      <td className="contractLine__cell contractLine__description" width="200">
        {contract.description}
      </td>
    </tr>
  );
};

export default ContractLine;
